/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Amount
 */
export interface Amount {
    /**
     * 
     * @type {string}
     * @memberof Amount
     */
    currencyCode: string;
    /**
     * 
     * @type {number}
     * @memberof Amount
     */
    amount: number;
}

/**
 * Check if a given object implements the Amount interface.
 */
// @ts-ignore
export function instanceOfAmount(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "currencyCode" in value;
    isInstance = isInstance && "amount" in value;

    return isInstance;
}

// @ts-ignore
export function AmountFromJSON(json: any): Amount {
    return AmountFromJSONTyped(json, false);
}

// @ts-ignore
export function AmountFromJSONTyped(json: any, ignoreDiscriminator: boolean): Amount {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'currencyCode': json['currency_code'],
        'amount': json['amount'],
    };
}

// @ts-ignore
export function AmountToJSON(value?: Amount | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'currency_code': value.currencyCode,
        'amount': value.amount,
    };
}

